import React from "react";
import { object, array, string, number, bool } from "prop-types";

import LinkTag from "../../molecules/link-tag";
import CardImage from "../../atoms/cardimage";
import Headline from "../../atoms/headline";

import { getHeadline } from "../../utils/utils";

import "./customStoryCard8.m.css";

const CustomStoryCard8 = ({ story, aspectRatio, imageType, widths, headerType, isExternalStory }) => {
  const headline = getHeadline(story);

  return (
    <LinkTag href={story.url} styleName="wrapper" className="custom-story-card-8" isExternalStory={isExternalStory}>
      <Headline text={headline} headerType={headerType} story={story} />

      <CardImage story={story} aspectRatio={aspectRatio} imageType={imageType} widths={widths} eager={true} />
    </LinkTag>
  );
};

CustomStoryCard8.defaultProps = {
  aspectRatio: [16, 9],
  imageType: "image16x9",
  headerType: 4,
  widths: [110],
  isExternalStory: false,
};

CustomStoryCard8.propTypes = {
  story: object.isRequired,
  aspectRatio: array,
  imageType: string,
  widths: array,
  headerType: number,
  isExternalStory: bool,
};

export default CustomStoryCard8;
